var Curriculog = Curriculog || {};
Curriculog.ProposalForm = Curriculog.ProposalForm || {};

Curriculog.ProposalForm.AssessmentFieldItem = (function ($, _, Backbone, AssessmentFieldItem) {

    AssessmentFieldItem = Curriculog.ProposalForm.Field.extend({

        events: {
            'click .fieldset-buttons button.save-field': 'save',
            'click .fieldset-buttons button.remove-assessment': 'remove',
        },

        initialize: function(options) {
            this.userPermissions = options.userPermissions;
            // this.item = options.item;
            this.field = options.field;
            this.section = options.section;
            this.proposal = options.proposal;
            this.setElement(options.item);

            this.model = {
                id: this.$el.data('id'),
                categoryID: this.$el.data('category-id'),
                objectiveID: this.$el.data('objective-id'),
                value: this.getValue(),
            };
            this.mode = this.field.mode;
            this.ckeditor = null;

            this.render();
        },

        render: function() {
            // ATM the subview is recreated each time it is updated,
            // so there is no need to update anything here.
            return true;
        },

        afterEdit: function() {
            var that = this;
            this.$('textarea.ckeditor').ckeditor(function(){
                that.ckeditor = this;
                this.on('instanceReady', function() {
                    this.document.on('drop', function(event) {
                        event.data.preventDefault(true);
                    });
                    this.focus();
                });
            });
        },

        destroy: function() {
            if (this.ckeditor) {
                this.ckeditor.destroy();
            }
        },

        getValue: function() {
            var $field = this.$('.field-placeholder');
            // if (this.mode == 'view') {
            if ($field.is('textarea, input, select')) {
                return $field.val();
            } else {
                return $field.html();
            }
        },

        setValue: function(value) {
            if (this.mode == 'view') {
                this.$('.field-placeholder').html(value);
            } else {
                this.$('.field-placeholder').val(value);
            }
        },

        save: function(event) {
            var defer = $.Deferred();
            console.log('Backbone:Item:save');
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
            if (! this.validateField()){
                defer.reject();
                return defer.promise();
            }
            // assessmentObject.saveProposalAssessment(fieldId, orderIndex, editList);
            // TODO: dont hack this into the old assessments object
            // assessmentObject.saveProposalAssessment(this.field.model.id, this.model.id, this.field.model.editList);
            var that = this;
            var fieldId = this.field.model.id;
            var orderIndex = this.model.id;
            var editList = this.field.model.editList;
            var index = 0;
            $('.field-'+ fieldId +' .curriculog-smartfield-dropzone').each(function(i) {
                var match = $(this).attr('class').match(new RegExp('field-' + fieldId + '-' + orderIndex));
                if (match !== undefined && match !== null) {
                    index = i;
                }
            });
            // data = {};
            assessments = [];
            assessments[0] = {
                id: +orderIndex,
                category: +$('input[id="field-'+ fieldId +'-'+ orderIndex +'-category"]').val(),
                categoryName: $('.field-'+ fieldId +'-'+ orderIndex ).find('.category').html(),
                objectiveID: +$('input[id="field-'+fieldId+'-'+orderIndex+'-objective"]').val(),
                proposalFieldID: +fieldId,
                inventoryID: $('#inventoryId').val(),// huh? there is NO mention of an #inventoryId in curriculog
                // value: $('#field-'+fieldId+'-'+orderIndex+'-assessment').val(),
                value: this.getValue(),
                status: 'active',
                orderIndex: index
            };
            // data.assessments = JSON.stringify(assessments);
            // data.editList = JSON.stringify(editList);
            // data.proposalStatus = $('#status').val();
            // data.display = 'conflictDiff';

            $.ajax({
                url: '/assessment/saveAssessments.ajax',
                type: 'PUT',
                data: {
                    display: 'conflictDiff',
                    assessments: JSON.stringify(assessments),
                    editList: JSON.stringify(editList),
                    proposalStatus: this.proposal.status,
                },
                beforeSend: function() {
                    // objDom.addMask('.field-'+ fieldId +'-'+ orderIndex);
                    that.addMask(that.$el);
                },
                success: function(data) {
                    // objDom.removeMask('.field-'+ fieldId +'-'+ orderIndex);

                    // if conflict, data will include the html for the conflict dialog and save was unsuccessful
                    if (data.length > 11) {
                        // proposalObject.showConflict(data, fieldId, orderIndex, 'assessment');
                        var conflict = new Curriculog.ProposalForm.FieldConflict({
                            field: that,
                            data: data,
                        }).promise();

                        conflict.fail(function() {
                            that.removeMask(that.$el);
                            defer.reject();
                        }).done(function(corrected_value) {
                            that.setValue(corrected_value);
                            that.save().always(function() {
                                // reset the edit list so we dont overwrite any other conflicts.
                                that.model.editList = [0];
                            }).done(defer.resolve).fail(defer.reject);
                        });
                    } else {
                        that.removeMask(that.$el);
                    }

                }
            });


            return defer.promise();
        },

        remove: function(event) {
            console.log('Backbone:Item:remove');
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
            // According to helpers/ProposalFields.php@createAssessment,
            // we never add tracking into to assessments in edit mode (sadtrombone)
            var isTracked = false;
            assessmentObject.removeProposalAssessment(this.$el, isTracked);
        },

        isRichText: function() {
            return this.$el.hasClass('ckeditor');
        },

        validateField: function() {
            var $el = this.$el;
            var $input = $el.find('.field-placeholder');

            $.validity.start();

            if ($el.data('required')) {
                $input.require();
            }

            return $.validity.end().valid;
            // TODO: assessmentObject.noEmptyAssessments($('#' + field[0]), event);
            // return true;
        },

    });

    return AssessmentFieldItem;

})($, _, Backbone, Curriculog.ProposalForm.AssessmentFieldItem || {});